export type PlannerEnv = 'production' | 'cte';

export const CTE_BASE_URL = '/cte';
export const PROD_BASE_URL = '/prod';

export function envToBaseUrl(env: PlannerEnv): string {
  if (env === 'production') {
    return PROD_BASE_URL;
  } else if (env === 'cte') {
    return CTE_BASE_URL;
  }
  throw new Error(`env is not recognized: ${env}`);
}
